import useChannel from '../use-channel';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootPatronState } from '../use-patron-selector';
import { Feature, getFeatureFlag } from '../../models/features/features';

const useFollowChannelButtonState = ({
  channelId,
}: {
  channelId: string | number;
}) => {
  const { channel } = useChannel({ channelId });
  const { t } = useTranslation();
  const newLabel = useSelector((state: RootPatronState) =>
    getFeatureFlag(state, Feature.CHANNELS_TO_TOPICS_ENABLED)
  );

  const following = channel?.following ?? false;
  const disabled = channel?.mandatory_following ?? false;
  const label = following
    ? newLabel
      ? t('screens.explore.following')
      : t('screens.explore.joined')
    : newLabel
    ? t('screens.explore.follow')
    : t('screens.explore.join');

  const tooltip = disabled
    ? t('screens.explore.mandatory_following')
    : undefined;

  const aria = {
    'aria-label': label,
    'aria-disabled': disabled,
    'aria-pressed': following,
  };

  return {
    label,
    following,
    disabled,
    tooltip,
    aria,
  };
};

export { useFollowChannelButtonState };
